export const mockData = {
  services: [
    {
      id: 1,
      title: 'Trademark Registration',
      description: 'Lock down your brand before someone else does. Our attorneys file your application with the USPTO and track it through every stage until approval.',
      icon: 'Shield',
      features: ['24-Hour Filing', 'USPTO Monitoring', 'Flat-Fee Pricing']
    },
    {
      id: 2,
      title: 'Copyright Registration',
      description: 'Your original work deserves legal armor. We register your creative assets with the U.S. Copyright Office so you can enforce your rights anywhere.',
      icon: 'FileText',
      features: ['Fast Turnaround', 'Federal Protection', 'Enforcement Ready']
    },
    {
      id: 3,
      title: 'Business Formation',
      description: 'Launch your LLC, Corporation, or Nonprofit the right way. We handle state filings, EIN registration, and compliance so you can focus on growth.',
      icon: 'Building2',
      features: ['All 50 States', 'EIN Included', 'Compliance Support']
    },
    {
      id: 4,
      title: 'Trademark Search',
      description: 'Avoid costly conflicts before you file. Our comprehensive search scans federal, state, and common-law databases for marks that could block yours.',
      icon: 'Search',
      features: ['Federal & State Scan', 'Risk Assessment', 'Attorney Review']
    },
    {
      id: 5,
      title: 'Amazon Brand Registry',
      description: 'Protect your listings and unlock powerful selling tools on Amazon. We guide you from trademark to full Brand Registry enrollment.',
      icon: 'ShoppingBag',
      features: ['Listing Protection', 'A+ Content Access', 'Counterfeit Defense']
    }
  ],
  pricingPlans: [
    {
      id: 1,
      name: 'Starter',
      price: 45,
      features: [
        'Application Review',
        'USPTO E-Filing',
        'Basic Availability Search',
        'Status Notifications',
        'Digital Certificate'
      ],
      popular: false
    },
    {
      id: 2,
      name: 'Growth',
      price: 145,
      features: [
        'Application Review',
        'USPTO E-Filing',
        'Comprehensive Search',
        'Status Notifications',
        'Digital Certificate',
        'Direct-Hit Conflict Report',
        'Assigned Case Advisor'
      ],
      popular: false
    },
    {
      id: 3,
      name: 'Professional',
      price: 299,
      features: [
        'Attorney-Led Review',
        'Full Trademark Clearance Search',
        '3-Month Monitoring Service',
        'Digital Certificate',
        'Refusal Risk Analysis',
        'Complete Document Preparation & Filing'
      ],
      popular: true
    },
    {
      id: 4,
      name: 'Enterprise',
      price: 599,
      features: [
        'Registered IP Attorney Review & Filing',
        'Dedicated Filing Coordinator',
        'Private Registration Option',
        'Digital Certificate',
        '50-State Federal Clearance Report',
        'Priority USPTO E-Filing',
        'Cease & Desist Drafting',
        'Same-Day Submission',
        '12-Month Monitoring',
        'Direct-Hit Conflict Report',
        'Priority Case Manager',
        '24/7 Dashboard Access',
        'Approval Guarantee'
      ],
      popular: false
    }
  ],
  testimonials: [
    {
      id: 1,
      name: 'Priya Kapoor',
      role: 'Founder, Bloom Beauty Co.',
      image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=400&fit=crop&crop=faces&q=80&fm=jpg',
      text: 'We were about to launch nationally and realized our brand name was completely unprotected. The team filed everything within a day and kept us updated through the whole process. No surprises, no hidden charges, just results.'
    },
    {
      id: 2,
      name: 'Daniel Foster',
      role: 'CEO, Forge Digital Agency',
      image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop&crop=faces&q=80&fm=jpg',
      text: 'As a creative agency, our original work is our entire business. They walked us through copyright registration for our client deliverables and internal IP. Now our portfolio has legal protection that actually holds up in court.'
    },
    {
      id: 3,
      name: 'Rachel Kim',
      role: 'Co-Founder, NovaTech Solutions',
      image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400&h=400&fit=crop&crop=faces&q=80&fm=jpg',
      text: 'We needed an LLC set up in Delaware with a Texas registered agent. They handled everything, including the EIN and operating agreement. Saved us weeks of research and gave us the legal foundation to start raising capital.'
    },
    {
      id: 4,
      name: 'Michael Torres',
      role: 'Brand Manager, Summit Outdoors',
      image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop&crop=faces&q=80&fm=jpg',
      text: 'Before we filed our trademark, their search team uncovered three existing marks that would have triggered an office action. That early conflict detection saved us months of delay and thousands in legal fees down the road.'
    },
    {
      id: 5,
      name: 'Jessica Adams',
      role: 'Founder, PureGlow Supplements',
      image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&h=400&fit=crop&crop=faces&q=80&fm=jpg',
      text: 'Getting into Amazon Brand Registry was our top priority. The team handled our trademark filing and then guided us straight through the enrollment process. Within weeks, we had A+ Content, brand analytics, and counterfeit reporting tools live.'
    },
    {
      id: 6,
      name: 'Christopher Grant',
      role: 'Managing Partner, Apex Ventures',
      image: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400&h=400&fit=crop&crop=faces&q=80&fm=jpg',
      text: 'We manage IP for a portfolio of brands and needed a partner who could scale with us. Their process is consistent, their communication is clear, and their pricing is transparent. We now route all our portfolio filings through them.'
    },
    {
      id: 7,
      name: 'Amanda Liu',
      role: 'Creative Director, StudioVault',
      image: 'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=400&h=400&fit=crop&crop=faces&q=80&fm=jpg',
      text: 'I produce original design work for international clients and needed airtight copyright protection. They registered my entire portfolio efficiently and now I have the documentation to enforce my rights anywhere. Completely worth it.'
    },
    {
      id: 8,
      name: 'Ryan Patterson',
      role: 'E-commerce Director, TrailEdge',
      image: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=400&h=400&fit=crop&crop=faces&q=80&fm=jpg',
      text: 'Counterfeit sellers were hijacking our listings on Amazon. After getting our trademark and enrolling in Brand Registry through the team, we shut down every single unauthorized listing. Our revenue recovered within the first quarter.'
    }
  ],
  stats: [
    {
      id: 1,
      value: '10,000+',
      label: 'Brands Protected'
    },
    {
      id: 2,
      value: '24/7',
      label: 'Client Support'
    },
    {
      id: 3,
      value: '98%',
      label: 'Approval Rate & On-Time Filing'
    }
  ],
  processSteps: [
    {
      id: 1,
      title: 'Tell Us About Your Brand',
      description: 'Complete a quick intake form with your brand details. Our team reviews your submission and responds within hours.'
    },
    {
      id: 2,
      title: 'We Search, Prepare & File',
      description: 'Our attorneys run a thorough clearance search, draft your application, and submit it directly to the USPTO.'
    },
    {
      id: 3,
      title: 'Your Brand Is Protected',
      description: 'Track your application in real time. Once approved, receive your official registration certificate and monitoring alerts.'
    }
  ]
};
